import React, {
  useEffect,
  useRef,
  useState
} from "react";

import {
  GoogleAuthProvider,
  signInWithEmailAndPassword,
  signInWithPopup
} from "firebase/auth";

import { useNavigate } from "react-router-dom";
import auth from "./firebase";
import "./Login.css";
import imgCover from "./004.jpg";
import imgCharacter from "./Sin título.png";

/* PROVEEDOR DE GOOGLE */
const googleProvider = new GoogleAuthProvider();

googleProvider.setCustomParameters({
  prompt: "select_account"
});

const Login = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    username: "",
    password: ""
  });

  const [remember, setRemember] =
    useState(false);

  const [toast, setToast] = useState({
    show: false,
    message: "",
    isError: false
  });

  const [isLoading, setIsLoading] =
    useState(false);

  const [isGoogleLoading, setIsGoogleLoading] =
    useState(false);

  const cardRef = useRef(null);

  const showToast = (
    message,
    isError = false
  ) => {
    setToast({
      show: true,
      message,
      isError
    });

    setTimeout(() => {
      setToast({
        show: false,
        message: "",
        isError: false
      });
    }, 3000);
  };

  useEffect(() => {
    const savedUser =
      localStorage.getItem("noctra_user");

    if (savedUser) {
      setFormData((previous) => ({
        ...previous,
        username: savedUser
      }));

      setRemember(true);
      showToast("Bienvenido de nuevo");
    }
  }, []);

  const handleMouseMove = (event) => {
    if (!cardRef.current) {
      return;
    }

    const rect =
      cardRef.current.getBoundingClientRect();

    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    cardRef.current.style.setProperty(
      "--x",
      `${x}px`
    );

    cardRef.current.style.setProperty(
      "--y",
      `${y}px`
    );
  };

  const handleChange = (event) => {
    const { id, value } = event.target;

    setFormData((previous) => ({
      ...previous,
      [id]: value
    }));
  };

  /* INICIAR SESIÓN CON CORREO */
  const handleSubmit = async (event) => {
    event.preventDefault();

    const { username, password } =
      formData;

    if (username.length === 0) {
      showToast(
        "Ingresa tu usuario o correo",
        true
      );
      return;
    }

    if (password.length === 0) {
      showToast(
        "Ingresa tu contraseña",
        true
      );
      return;
    }

    try {
      setIsLoading(true);

      await signInWithEmailAndPassword(
        auth,
        username,
        password
      );

      if (remember) {
        localStorage.setItem(
          "noctra_user",
          username
        );
      } else {
        localStorage.removeItem(
          "noctra_user"
        );
      }

      showToast(
        "¡Bienvenido de vuelta!"
      );

      setTimeout(() => {
        navigate("/");
      }, 1000);
    } catch (error) {
      console.error(error);

      showToast(
        "Correo o contraseña incorrectos",
        true
      );
    } finally {
      setIsLoading(false);
    }
  };

  /* INICIAR SESIÓN CON GOOGLE */
  const handleGoogleLogin = async () => {
    try {
      setIsGoogleLoading(true);

      const result = await signInWithPopup(
        auth,
        googleProvider
      );

      const nombre =
        result.user.displayName ||
        result.user.email ||
        "usuario";

      if (remember && result.user.email) {
        localStorage.setItem(
          "noctra_user",
          result.user.email
        );
      }

      showToast(
        `¡Bienvenido, ${nombre}!`
      );

      setTimeout(() => {
        navigate("/");
      }, 1000);
    } catch (error) {
      console.error(error);

      if (
        error.code ===
        "auth/popup-closed-by-user"
      ) {
        showToast(
          "Cerraste la ventana de Google",
          true
        );
        return;
      }

      if (
        error.code ===
        "auth/popup-blocked"
      ) {
        showToast(
          "El navegador bloqueó la ventana de Google",
          true
        );
        return;
      }

      if (
        error.code ===
        "auth/unauthorized-domain"
      ) {
        showToast(
          "Este dominio no está autorizado en Firebase",
          true
        );
        return;
      }

      if (
        error.code ===
        "auth/account-exists-with-different-credential"
      ) {
        showToast(
          "Este correo ya utiliza otro método de inicio de sesión",
          true
        );
        return;
      }

      showToast(
        "No se pudo iniciar sesión con Google",
        true
      );
    } finally {
      setIsGoogleLoading(false);
    }
  };

  const handleForgotPassword = (
    event
  ) => {
    event.preventDefault();

    showToast(
      "Enviamos un enlace a tu correo"
    );

    console.log("Recuperar contraseña");
  };

  const handleSignup = (event) => {
    event.preventDefault();
    navigate("/register");
  };

  return (
    <div className="login-container">
      <div className="bg"></div>
      <div className="overlay"></div>
      <div className="glow"></div>

      <div className="wrapper">
        {/* LOGIN IZQUIERDA */}
        <div
          className="card"
          ref={cardRef}
          onMouseMove={handleMouseMove}
        >
          <div className="top">
            <div className="logo">
              TMOXNight
            </div>

            <div className="sub">
              WELCOME BACK · 18+
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="group">
              <input
                type="text"
                className="input"
                id="username"
                placeholder=" "
                required
                value={formData.username}
                onChange={handleChange}
              />

              <label className="label">
                Usuario o correo electrónico
              </label>
            </div>

            <div className="group">
              <input
                type="password"
                className="input"
                id="password"
                placeholder=" "
                required
                value={formData.password}
                onChange={handleChange}
              />

              <label className="label">
                Contraseña
              </label>
            </div>

            <div className="options">
              <label className="remember">
                <input
                  type="checkbox"
                  checked={remember}
                  onChange={(event) =>
                    setRemember(
                      event.target.checked
                    )
                  }
                />

                Recordarme
              </label>

              <a
                href="#recuperar"
                className="forgot"
                onClick={
                  handleForgotPassword
                }
              >
                ¿Olvidaste tu contraseña?
              </a>
            </div>

            <button
              className={`btn ${
                isLoading ? "loading" : ""
              }`}
              type="submit"
              disabled={
                isLoading ||
                isGoogleLoading
              }
            >
              {isLoading
                ? ""
                : "INICIAR SESIÓN"}
            </button>
          </form>

          <div className="divider">
            <span>O CONTINÚA CON</span>
          </div>

          {/* BOTÓN DE GOOGLE */}
          <button
            type="button"
            className="google-login-btn"
            onClick={handleGoogleLogin}
            disabled={
              isLoading ||
              isGoogleLoading
            }
          >
            <span className="google-login-icon">
              G
            </span>

            <span>
              {isGoogleLoading
                ? "CONECTANDO..."
                : "INICIAR SESIÓN CON GOOGLE"}
            </span>
          </button>

          <div className="bottom">
            ¿No tienes cuenta?

            <a
              href="/register"
              onClick={handleSignup}
            >
              Crear cuenta
            </a>
          </div>
        </div>

        {/* TARJETA 3D DERECHA */}
        <div className="card3d">
          <div className="wrapper3d">
            <img
              src={imgCover}
              className="cover-image"
              alt=""
            />
          </div>

          <img
            src={imgCharacter}
            className="character"
            alt=""
          />
        </div>
      </div>

      <div
        className={`toast ${
          toast.show ? "show" : ""
        } ${
          toast.isError ? "error" : ""
        }`}
      >
        {toast.message}
      </div>
    </div>
  );
};

export default Login;